// axiosInstance.js
import axios from "axios";
import { encryptData, decryptData } from "../cryptoUtils";

const baseUrl =
  window.location.hostname === "localhost"
    ? "http://localhost:8089/"
    : process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// 🔹 Request Interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (window.location.hostname !== "localhost") {
      // Skip encryption if explicitly asked
      if (!config.skipEncryption) {
        if (["get", "delete"].includes(config.method?.toLowerCase()) && config.params) {
          const { encryptedData, iv } = await encryptData(config.params);
          config.params = { encryptedData, iv };
        } else if (config.data && !(config.data instanceof FormData)) {
          const encrypted = await encryptData(config.data);
          config.data = encrypted;
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Response Interceptor
axiosInstance.interceptors.response.use(
  async (response) => {
    if (window.location.hostname !== "localhost") {
      try {
        const { encryptedData, iv } = response.data || {};
        if (encryptedData && iv) {
          response.data = await decryptData(encryptedData, iv);
        }
      } catch (err) {
        console.error("Decryption failed:", err);
      }
    }
    return response;
  },
  async (error) => {
    try {
      const { encryptedData, iv } = error.response?.data || {};
      if (encryptedData && iv) {
        error.response.data = await decryptData(encryptedData, iv);
      }
    } catch (err) {
      console.error("Error decryption failed:", err);
    }

    if (error.response?.data?.error === "Unauthorized user") {
      localStorage.removeItem("token");
      localStorage.removeItem("Privilliages");
      localStorage.removeItem("userData");
      localStorage.setItem("sessionExpired", "true");
      const params = new URLSearchParams(window.location.search);
      const paygroup_navigate = params.get("paygroup");
      const period_navigate = params.get("period");
      if(paygroup_navigate && period_navigate){
          const redirectUrl = window.location.pathname + window.location.search;
          localStorage.setItem("redirectAfterLogin", redirectUrl);
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
